import axios from 'axios';
import { TagMutations } from '../graphql/tag.mutations';
import { TagQueries } from '../graphql/tag.queries';
import { EFetchPolicy } from '@/api/types/enums/fetch-policy';
import { apolloClient } from '@/apollo';
import { ITag } from '@lib-shared/types/Tag';

export class TagService {
  static async load(): Promise<ITag[]> {
    const {
      data: { tags },
    } = await apolloClient.query({
      query: TagQueries.load,
      fetchPolicy: EFetchPolicy.NetworkOnly,
    });
    return tags;
  }

  static async addMultiple(documentIds: string[], tagIds: string[]): Promise<any[]> {
    const {
      data: { addDocumentTags },
    } = await apolloClient.mutate({
      mutation: TagMutations.addMultiple,
      variables: { documentIds, tagIds },
    });
    return addDocumentTags;
  }

  static async create(tagName: string): Promise<ITag> {
    const {
      data: { createTag },
    } = await apolloClient.mutate({
      mutation: TagMutations.create,
      variables: { title: tagName },
    });
    return createTag;
  }

  static async removeMultiple(documentIds: string[], tagIds: string[]): Promise<boolean> {
    const {
      data: { removeDocumentTags },
    } = await apolloClient.mutate({
      mutation: TagMutations.removeMultiple,
      variables: { documentIds, tagIds },
    });
    return removeDocumentTags;
  }

  static async legacyUpdateDocument(documentId: string, tags: ITag[]) {
    let tagString = '';
    if (tags.length) {
      tagString = tags.map(tag => tag.title).toString();
    }
    const body = new FormData();
    body.append('action', 'data');
    body.append('document-id', documentId);
    body.append('field', 'document-tags');
    body.append('value', tagString);

    const {
      data: { document_id, error },
    } = await axios.post('/save/document', body);
    if (error) {
      throw new Error(error);
    }
    return document_id;
  }
}
